import { apiRequest } from '../../api/client';

const unwrap = <T>(promise: Promise<{ data: T }>): Promise<T> => promise.then((e) => e.data);

export interface CustomerCareGroup {
  id: string;
  name: string;
  url: string;
  isEnabled: boolean;
  sortOrder: number;
}

export interface UpsertCustomerCareGroupPayload {
  name: string;
  url: string;
  isEnabled: boolean;
  sortOrder: number;
}

export const customerCareGroupKeys = {
  all: ['customer-care-groups'] as const,
  list: ['customer-care-groups', 'list'] as const,
};

export const customerCareGroupApi = {
  list: () => unwrap(apiRequest<CustomerCareGroup[]>('/admin/customer-care-groups')),

  create: (body: UpsertCustomerCareGroupPayload) =>
    unwrap(apiRequest<CustomerCareGroup>('/admin/customer-care-groups', { method: 'POST', body })),

  update: (id: string, body: UpsertCustomerCareGroupPayload) =>
    unwrap(
      apiRequest<CustomerCareGroup>(`/admin/customer-care-groups/${id}`, { method: 'PUT', body }),
    ),

  remove: (id: string) =>
    unwrap(apiRequest<void>(`/admin/customer-care-groups/${id}`, { method: 'DELETE' })),
};
